module.exports = __webpack_public_path__ + "logo_9444-8b50cc5bd4efea6afd4047782dfd8f92.png";


//////////////////
// WEBPACK FOOTER
// ./assets/leagues/logo_9444.png
// module id = 1147
// module chunks = 0 1